export default __webpack_public_path__ + "static/React-b37f0a4b7134b3c99d6ef572fcf2a511.png";